/**
 * api接口统一管理
 */
import { get, post, post1 } from './http'

// 登录
export const h5login = p => post1('/learn/h5login?' + p)
// 验证码
export const sendCode = p => post1('/learn/sendAuthCode?' + p)
// 课表获取某月课表
export const basCourseMonth = p => post('/learn/college/bas/course/month?' + p)
// 课表获取某日课表
export const basCourseDay = p => post('/learn/college/bas/course/day?' + p)
// 课程详情
export const basCourseDetail = p => post('/learn/college/bas/course/detail?' + p)
// 课程学员签到
export const basCourseAttend = p => post('/learn/college/bas/course/attend', p)
